export class QuizData{
// risk quiz
    age: Number = 0;
    weight: Number =   0;
    height: string =   '';
    gender:Number=  0 ;
    family: Number =   0;
    ethnicity:Number =   0;
    bp:Number=  0 ;
    active: Number =   0;
    gestational:Number =   0;
    score:Number =  0;

    // motivation quiz
    motivation:Number[] = [0,0,0];
    motiv : Number[] = [0];
    whyChange : Number[] = [0];
    habit:Number = 0;
    whatHappen : Number[] = [0];

    // demographic quiz
    enrolled: Number = 0;
    zip: Number = 0;
    education: Number = 0;
    payer: Number = 0;
    diabetes: Number = 0;
    prediabetes: Number = 0;

    //program goals
    weightGoal: Number = 0;
    activityGoal: Number = 0;
    activitycaloriesGoal: Number = 0;
    foodcaloriesGoal: Number = 0;
    stepsGoal: Number = 0;

    // lifestylequiz
    loggingchallenges: String = '';
    freetimes: String = '';
    favoriteexercises: String = '';
    overeattrigs: String = '';
    lvlstress = '';
    reasonstress: String = '';
    dealstress: String = '';
    smoke: String = '';
    enjoywork: String = '';
    dailysleep: String = '';
    weeklyexercise: String = '';
    stayuplate: String = '';
    worklong: String = '';
    watchplaybrowse: String = '';
    socialsupport: String = '';
    hoursSleep:String ='';
    qualitySleep:String ='';
    exerciseMore30:String ='';
    maritalStatus:String ='';
    
    //Food Quiz
    typicalmeals:String='';
    ownmeals:String='';
    dailydrinks:String='';
    weeklyalcohol:String='';
    weeklyprocessedmeats:String='';
    weeklyrefinedcarbs:String='';
    weeklyfriedfoods:String='';
    weeklydesserts:String='';
    fastFood='';
    fruitsAndVeggies='';
    calorieInformation='';

    //SDOH Quiz
    household_member:Number =0;
    family_income:Number = 0;
    basic_requirements = '';
    supported_by='';
    housing_situation='';
    current_problems='';
    work_situation='';
    current_work='';
    refugee='';
    discrimination='';
    crime_records='';
    afraid_of_partner='';
    primary_member_situation='';
    discharged_from_armed_forces='';
    fluent_english='';
    understanding_insurance_benifits='';
    counseling = '';
    related_problems = '';
    regularSources = '';
    qualityGroceries = '';

    //Comorbidity Quiz
    preexisting_conditions='';
    health_status ='';

    //Preference Quiz
    preference_expert='';
    preference_health_education='';
    smartphone_usage='';

    //Coach Feedback
    weekly_log='';
    positives_negatives='';
    specific_suggestion='';

    phone:String = "";
}